

import {Component, Vue, Prop} from 'vue-property-decorator';
import user_module from '@/modules/user/index';

@Component
export default class RequestButton extends Vue {

  source: string = ''

  @Prop({ default: ''}) extraClass!: string;

  created(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const source = urlParams.get('source')
    
    if (source){
      this.source = source;
    }
  }

  get expired(){
    return user_module.expired;
  }

  get buttonText(){

    let text = this.bought && !this.expired ? 'START' : 'REQUEST DEMO';

    if (this.extraClass === 'secondary'){

      text = text.toLowerCase();
    }

    return text;

  }

  get product(){

    return user_module.userProducts.find(product => product.id === this.$route.meta.product)

  }

  get bought(){

    return this.product?.bought && this.product.id !== 'proplus';
  }

  get productLink(){


    console.log('this.product', this.product)

    return this.product?.defaultLink
  }

  get productRD(){

    let base = '/requestdemo/' + (this.product ? this.product.site : 'TM?source=frommenu');
    
    return base + (this.source ? '?source=' + this.source : '');
  }


}

